<i18n>
{
	"en": {
		"save": "Save",
		"title": "Create new user",
		"name": "Name",
		"email": "E-mail address",
		"admin": "Administrator",
		"failedToCreateUser": "Failed to create user",
		"createdUser": "User created successfully"
	},
	"no": {
		"save": "Lagre",
		"title": "Opprett ny bruker",
		"name": "Navn",
		"email": "E-post adresse",
		"admin": "Administrator",
		"failedToCreateUser": "Kunne ikke opprette brukeren",
		"createdUser": "Opprettet ny bruker"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="showNewUserModal"
		:title=" $t('title') "
		:confirmLabel=" $t('save') "
		:isConfirmDisabled="confirmDisabled"
		icon="person"
		iconType="bp"
		@ok="save"
		@close="close"
	>
		<div class="new-user">
			<t-form-group :title=" $t('name') " style="grid-column: 1/3;">
				<t-text-input-button
					:value="newUserData.name"
					icon="person"
					@input="setNewUserData({ key: 'name', value: $event })"
				/>
			</t-form-group>

			<hr>

			<t-form-group :title=" $t('email') " style="grid-column: 1/3">
				<t-text-input-button
					:value="newUserData.email"
					icon="envelope"
					@input="setNewUserData({ key: 'email', value: $event })"
				/>
				<t-checkbox
					:label=" $t('admin')"
					:checked="newUserData.super"
					@change="setNewUserData({ key: 'super', value: $event })"
				/>
			</t-form-group>
		</div>
	</t-dialog>
</template>

<script>
import {
	mapState, mapActions, mapMutations
} from './store/users.store.js';

export default {
	name: 'NewUser',
	computed: {
		...mapState([
			'showNewUserModal',
			'newUserData',
		]),
		confirmDisabled() {
			if (this.newUserData.name.length < 3 || this.newUserData.email.length < 3 || !this.newUserData.email.includes('@')) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		...mapActions(['createUser']),
		...mapMutations([
			'toggleNewUserModal',
			'resetNew',
			'setNewUserData'
		]),
		async save() {
			try {
				await this.createUser();
				this.$notify({ type: 'success', title: this.$t('createdUser') });
			} catch (e) {
				this.$notify({ type: 'error', title: this.$t('failedToCreateUser') });
			}
		},
		close() {
			this.resetNew();
			this.toggleNewUserModal(false);
		},
	}
};
</script>

<style lang="scss" scoped>
@import "~@/components/evergreen/scss/colors";
.new-user {
	display: grid;
	grid-template-columns: repeat(2, minmax(220px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}
hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, "default");
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
}
</style>

